
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mtdsorted",
      function () {
        return require("private-next-pages/mtdsorted/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mtdsorted"])
      });
    }
  